import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { SERVER_URL } from '../../config';
import { formatDate } from '../../utils/date'
import { throttle } from 'lodash';

import { scrollToPage, updateMainHeaderColor, calculateNextPage } from '../../services/scrollService';
import { animationController, removeMainTransClass } from '../../services/mainService';
import { fetchCertData } from '../../services/certService'
import { fetchGalleryListData, fetchGalleryDetailData } from '../../services/portfolioService'
import { fetchNoticeListData } from '../../services/noticeService'

import { swiperSlides, prdCards as initialPrdCards, circleBorderCards, circleCards, fieldCards } from './MainData';

import { mainTopBack, prdBlack1, prdBlack4, prdBlack3, prdBlack2, prdWhite1, prdWhite2, prdWhite3, prdWhite4, prdReader, prdTag, prdIcCard, prdPrinter } from '../../assets/images/main/mainImages';

import './MainPage.css';

import MainSwiper from '../../components/Swiper/MainSwiper';
import MainProductCard from '../../components/Card/MainProductCard';
import MainImageCard from '../../components/Card/MainImageCard';
import MainFieldCard from '../../components/Card/MainFieldCard';
import MainCircleBorderCard from '../../components/Card/MainCircleBorderCard';
import MainCircleCard from '../../components/Card/MainCircleCard';
import Map from '../../components/Map/Map';
import BorderBottomList from '../../components/List/BorderBottomList';
import Footer from '../../components/Footer/Footer';
import MainPopup from '../../components/Popup/MainPopup';
import DetailModal from '../../components/Modal/DetailModal';

const Main = () => {

  const [cert, setCert] = useState([]);
  const [portfolio, setPortfolio] = useState([]);
  const [notice, setNotice] = useState([]);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [dgDetailData, setDgDetailData] = useState();
  const [prdCards, setPrdCards] = useState(initialPrdCards);
  const [prdImg, setPrdImg] = useState(prdReader);
  const prdWhiteImages = [prdWhite1, prdWhite2, prdWhite3, prdWhite4];
  const prdBlackImages = [prdBlack1, prdBlack2, prdBlack3, prdBlack4];


  const location = useLocation();

  const PAGE_HEIGHT = document.documentElement.clientHeight;
  const DIVIDER_HEIGHT = 0;
  const TOTAL_PAGES = 10;

  const outerDivRef = useRef();
  const [currentPage, setCurrentPage] = useState(1);

  const handleSlideButtonClick = (idx) => {
    setCurrentPage(idx + 1);
    const element = document.getElementById(`section-${idx}`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      updateMainHeaderColor(idx + 1);
      animationController(idx, 'P');
    }
    handleMenuChange(idx);
  };
  
  const handleMenuChange = useCallback((currentPage) => {
    let idx = currentPage;

    if(idx < 0) {
      idx = 0;
    }
    
    const menuElements = document.querySelectorAll('[id^="main-menu-"]');
    
    if (idx !== 0 && idx !== 2 && idx !==7) {
      for (const element of menuElements) {
        element.classList.remove('on');
        element.classList.add('off');
      }
    } else {
      for (const element of menuElements) {
        element.classList.remove('on');
        element.classList.remove('off');
      }
    }
    const currentElement = document.querySelector(`#main-menu-${idx}`);
    if (currentElement) {
      currentElement.classList.add('on');
      currentElement.classList.remove('off');
    }
  }, []);
  
  const [sectionVisibility, setSectionVisibility] = useState([false, false, false, false, false, false, false, false]);
  const sectionRefs = useRef([]);

  useEffect(() => {
    const options = {
      threshold: 0.4,
    };

    const callback = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const index = Number(entry.target.dataset.index);
          setSectionVisibility(prevVisibility => {
            const updatedVisibility = [...prevVisibility];
            updatedVisibility[index] = entry.isIntersecting;
            return updatedVisibility;
          });
        } else {
          const index = Number(entry.target.dataset.index);
          setSectionVisibility(prevVisibility => {
            const updatedVisibility = [...prevVisibility];
            updatedVisibility[index] = false;
            return updatedVisibility;
          });
        }
      });
    };

    const observer = new IntersectionObserver(callback, options);

    sectionRefs.current.forEach((sectionRef, index) => {
      if (sectionRef) {
        observer.observe(sectionRef);
      }
    });

    return () => {
      sectionRefs.current.forEach((sectionRef) => {
        if (sectionRef) {
          observer.unobserve(sectionRef);
        }
      });
    };
  }, []);

  
  useEffect(() => {
    removeMainTransClass();
    sectionVisibility.forEach((isVisible, index) => {
      if (isVisible) {
        switch (index) {
          case 1:
            animationController(1, 'P');
            break;
          case 2:
            animationController(2, 'P');
            break;
          case 3:
            animationController(3, 'P');
            break;
          case 4:
            animationController(4, 'P');
            break;
          case 5:
            animationController(5, 'P');
            break;
          case 6:
            animationController(6, 'P');
            break;
          case 7:
            animationController(7, 'P');
            break;
        }
      }
    });


  }, [sectionVisibility]);


  useEffect(() => {
    const wheelHandler = (e) => {
      
      e.preventDefault();
      const { deltaY } = e;
      
      const nextPage = calculateNextPage(deltaY, currentPage, TOTAL_PAGES);
      scrollToPage(outerDivRef, PAGE_HEIGHT, DIVIDER_HEIGHT, nextPage);
      
      if(deltaY > 0) {
        handleMenuChange(nextPage-1);
      } else {
        handleMenuChange(nextPage-1);
      }
      setCurrentPage(nextPage);
      updateMainHeaderColor(nextPage);
      
    };
    
    const outerDivRefCurrent = outerDivRef.current;
    if (location.pathname === '/') {
      document.addEventListener("wheel", wheelHandler, { capture: true, passive: false });
    } else {
      outerDivRefCurrent.addEventListener("wheel", wheelHandler, { capture: true, passive: false });
    }
    
    return () => {
      document.removeEventListener("wheel", wheelHandler, { capture: true, passive: false });
    };

  }, [currentPage]);

  const handlePrdImg = async (prdImgidx) => {
    switch(prdImgidx) {
      case 0: setPrdImg(prdReader); break;
      case 1: setPrdImg(prdTag); break;
      case 2: setPrdImg(prdIcCard); break;
      case 3: setPrdImg(prdPrinter); break;
    }

    setPrdCards(prevCards => {
      const updatedCards = prevCards.map((card, index) => {
        const newWrapClass = card.wrapClass.split(' ').map(cls => {
          if (cls === 'prd-card-div1' || cls === 'prd-card-div2') {
            return (index === prdImgidx ? 'prd-card-div1' : 'prd-card-div2');
          }
          return cls;
        }).join(' ');
        
        return {
          ...card,
          imgPath: index === prdImgidx ? prdWhiteImages[index] : prdBlackImages[index],
          wrapClass: newWrapClass + (newWrapClass.includes('show') ? '' : ' show'),
        };
      });
      return updatedCards;
    });
  };

  useEffect(() => {
    const certListData = async () => {
      const certData = await fetchCertData(4);
      setCert(certData);
    };

    const portfolioListData = async () => {
      const pfData = await fetchGalleryListData(8, null);
      setPortfolio(pfData.dgList);
    };

    const noticeListData = async () => {
      const ntData = await fetchNoticeListData(4, null, null, null);
      setNotice(ntData.ntList);
    };

    certListData();
    portfolioListData();
    noticeListData();
  }, []);

  const openDetailModal = async (idx) => {
    const galleryDetailData = await fetchGalleryDetailData(idx);
    setDgDetailData(galleryDetailData);
    setIsDetailModalOpen(true);
  }

  const closeDetailModal = () => {
    setIsDetailModalOpen(false);
    setDgDetailData(null);
  }
  
  const slides = [
    {
      content: (
        <div id='section-0' className='main-section-con' ref={el => (sectionRefs.current[0] = el)} data-index={0}>
          <div className='block-div'></div>
          <img id='main-back-img' src={mainTopBack} />
            <MainSwiper slides={swiperSlides} />
        </div>
      ),
    },
    {
      content: (
        <div id='section-1' className='main-section-con bg-white' ref={el => (sectionRefs.current[1] = el)} data-index={1}>
          <div className='block-div'></div>
          
          <div className='row-flex-div inner-container'>
            <div id='main-prd-intro'>
              <div className='main-center-title'>Product</div>
              <p id='main-prd-intro-content' className='main-trans-b-t'>엠포플러스(주)는<br/>
                다양한 기업의 비즈니스 니즈를 해결하기 위한<br/>
                제품을 소개합니다.
              </p>
              <div id='prdImgDiv'>
                <img src={prdImg} alt='제품이미지' id='main-prd-intro-img' className='main-trans-b-t' />
              </div>
            </div>
            <div id='product-card-wrap' className='inner-container'>
              {prdCards.map((prdCard, index) => (
                <Link key={index} onMouseOver={() => handlePrdImg(index)} className='text-line-none' to={prdCard.linkUrl}>
                  <MainProductCard cardId={`prd-card-${index}`} prdCards={prdCards[index]} />
                </Link>
              ))}
            </div>
          </div>
        </div>
      ),
    },
    {
      content: (
        <div id='section-2' className='main-section-con'  ref={el => (sectionRefs.current[2] = el)} data-index={2}>
          <div className='block-div'></div>
          <div className='flex-div mb-100'>
            <div className='sol-main-center-title'>Solution</div>
            <div className='sol-main-center-content'>
              고객님들의 편의를 위한 다양한 솔루션을 제공합니다.
            </div>
            <div id='sol-circle-wrap'>
              {circleBorderCards.map((circleBorderCard, index) => (
                  <MainCircleBorderCard key={index} cardId={`sol-circle-card-${index}`} circleBorderCards={circleBorderCards[index]}/>
              ))}
            </div>
          </div>
        </div>
      ),
    },
    {
      content: (
        <div id='section-3' className='main-section-con bg-white' ref={el => (sectionRefs.current[3] = el)} data-index={3}>
          <div className='block-div'></div>
          <div className='flex-div'>
            <div className='main-center-title'>Certification</div>
            <div className='main-center-content'>
              RFEMFO 의 인증현황 입니다.
            </div>
            <div id='cert-card-wrap'>
              {cert.map((item, index) => (
                <MainImageCard 
                  key={index} 
                  imgPath={SERVER_URL + item.CT_THUMBNAIL_PATH}
                  title={item.CT_TITLE}
                  cardId={`main-cert-card-${index}`}
                  wrapClass={'main-trans-b-t cert-card-div'}
                  imgClass={'cert-card-img'}
                  titleClass={'cert-card-title'}
                />
              ))}
            </div>
            <div id='main-cert-more-btn' className='main-more-btn main-trans-b-t'>
              <Link className='text-line-none' to={'/company/certList'}>
                + 더보기
              </Link>
            </div>
          </div>
        </div>
      ),
    },
    {
      content: (
        <div id='section-4' className='main-section-con bg-white' ref={el => (sectionRefs.current[4] = el)} data-index={4}>
          <div className='block-div'></div>
          <div className='flex-div'>
            <div className='main-center-title'>Portfolio</div>
            <div className='main-center-content'>
              RFEMFO 납품갤러리 입니다.
            </div>
            <div id='pf-card-wrap'>
              {portfolio ? portfolio.map((item, index) => (
                <div key={index+4} onClick={() => openDetailModal(item.DG_IDX)}>
                  <MainImageCard 
                    imgPath={SERVER_URL + item.DG_THUMBNAIL}
                    title={item.DG_TITLE}
                    cardId={`main-pf-card-${index}`}
                    wrapClass={'main-trans-b-t cert-card-div'}
                    imgClass={'pf-card-img'}
                    titleClass={'cert-card-title'}
                  />
                </div>
              )) : ''}
            </div>
            {isDetailModalOpen && (
              <DetailModal isOpen={isDetailModalOpen} onClose={closeDetailModal} data={dgDetailData} imgUrl={SERVER_URL}/>
            )}
            <div id='main-pf-more-btn' className='main-more-btn main-trans-b-t'>
              <Link className='text-line-none ' to={'/portfolio/delivery/1'}>
                + 더보기 
              </Link>
            </div>
          </div>
        </div>
      ),
    },
    {
      content: (
        <div id='section-5' className='main-section-con bg-white' ref={el => (sectionRefs.current[5] = el)} data-index={5}>
          <div className='block-div'></div>
          <div className='flex-div'>
            <div className='main-center-title mb-10'>RFID / NFC 활용분야</div>
            <div id='circle-box-wrap'>
              {circleCards.map((circleCard, index) => (
                <MainCircleCard 
                  key={index} 
                  circleCards={circleCards[index]} 
                />
              ))}
              
            </div>
            <div id='field-card-wrap'>
              {fieldCards.map((fieldCard, index) => (
                <MainFieldCard key={index} fieldCards={fieldCards[index]} />
              ))}
            </div>
          </div>
        </div>
      ),
    },
    {
      content: (
        <div id='section-6' className='main-section-con bg-white' ref={el => (sectionRefs.current[6] = el)} data-index={6}>
          <div className='block-div'></div>
          <div className='main-center-title'>Notice</div>
          <div id='notice-list-wrap'>
            {notice ? notice.map((item, index) => (
              <BorderBottomList 
                key={index}
                keyprop={item.NT_IDX}
                date={formatDate(item.NT_INPUT_DATE)}
                title={item.NT_TITLE}
                divId={`main-nt-div-${index}`}
                wrapClass={'main-trans-b-t'}
                url={`/support/notice/detail/${item.NT_IDX}`}
              /> 
            )) : ''}
          </div>
          <div id='main-nt-more-btn' className='main-more-btn main-trans-b-t'>
            <Link className='text-line-none' to={'/support/notice/1'}>
              + 더보기
            </Link>
            </div>
        </div>
      ),
    },
    {
      content: (
        <div id='section-7' className='main-section-con bg-white' ref={el => (sectionRefs.current[7] = el)} data-index={7}>
          <div className='block-div'></div>
          <div id='contact-wrap'>
            <Link to={'/company/way'}>
              <div id='map-div'>
                <Map />
              </div>
            </Link>
            <div id='contact-div'>
              <div id='main-cont-div-0' className='main-trans-b-t'>
                <span className='sol-main-center-title'>Contact us</span><br />
                EMFOPLUS are always welcome<br /><br />
              </div>
              <div id='main-cont-div-1' className='main-trans-b-t'>
                <span className='contact-sub-title'>Add</span><br /><br />

                서울시 성동구 아차산로 17길 48<br />
                SK V1센터 1동 1615-1620호<br /><br />

                48, Achasan-ro 17-gil, Seongdong-gu, Seoul,<br />
                Republic of Korea
              </div>
              <div id='main-cont-div-2' className='main-trans-b-t'>
                <span className='contact-sub-title'>Tel</span><br /><br />

                TEL. 1599-2320 <br />
                E-MAIL. rfid@emfoplus.co.kr
              </div>
            </div>
          </div>
        </div>
      ),
    },
  ];

  

  return (
    
    <div ref={outerDivRef} className="outer">
      <MainPopup />
      

      <div id='main-fix-line'>
        <ul id='main-slide-ul'>
          <li id='main-menu-0' className='on'>
            <a onClick={() => handleSlideButtonClick(0)}>Main</a>
          </li>
          <li id='main-menu-1'>
            <a onClick={() => handleSlideButtonClick(1)} >Product</a>
          </li>
          <li id='main-menu-2'>
            <a onClick={() => handleSlideButtonClick(2)}>Solution</a>
          </li>
          <li id='main-menu-3'>
            <a onClick={() => handleSlideButtonClick(3)}>Certification</a>
          </li>
          <li id='main-menu-4'>
            <a onClick={() => handleSlideButtonClick(4)}>Portfolio</a>
          </li>
          <li id='main-menu-5'>
            <a onClick={() => handleSlideButtonClick(5)}>Company</a>
          </li>
          <li id='main-menu-6'>
            <a onClick={() => handleSlideButtonClick(6)}>Notice</a>
          </li>
          <li id='main-menu-7'>
            <a onClick={() => handleSlideButtonClick(7)}>Contact</a>
          </li>
        </ul>
      </div>
      {slides.map((slide, index) => (
        <div key={index}>
          {slide.content}
        </div>
      ))}
    <Footer id='main-menu-8' />
    </div>
  );
};

export default Main;
